/**
 * /semanadafisio-aulas — catálogo da Semana da Fisioterapia exibido logo após
 * a captura das aulas experimentais das pós. Igual à LP da ação, com uma tarja
 * superior confirmando a entrega das aulas gratuitas por e-mail.
 *
 * Fora da ação, a captura das aulas volta a direcionar para /pos.
 */
import { createFileRoute } from "@tanstack/react-router";

import { SemanaFisioPage } from "@/components/lps/SemanaFisioPage";
import { getAcoesStateFn } from "@/lib/campanhas/acoes.functions";

export const Route = createFileRoute("/semanadafisio-aulas")({
  validateSearch: (search: Record<string, unknown>): { preview?: boolean } =>
    search.preview === "1" || search.preview === 1 || search.preview === true
      ? { preview: true }
      : {},
  head: () => ({
    meta: [
      { title: "Suas aulas gratuitas · Semana da Fisioterapia" },
      {
        name: "description",
        content:
          "Suas aulas experimentais já estão no seu e-mail. Aproveite as ofertas da Semana da Fisioterapia em pós-graduações, certificações, Star Cursos, Aprova FEO e Agente IA.",
      },
      { property: "og:title", content: "Suas aulas gratuitas · Semana da Fisioterapia" },
      {
        property: "og:description",
        content: "Aulas enviadas por e-mail e ofertas da Semana da Fisioterapia com até 80% de desconto.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  loader: () => getAcoesStateFn(),
  component: SemanaFisioAulasRoute,
});

function SemanaFisioAulasRoute() {
  const acoes = Route.useLoaderData();
  const { preview } = Route.useSearch();
  const ativa = Boolean(acoes?.semanadafisio?.ativa) || preview === true;
  return <SemanaFisioPage ativa={ativa} avisoTop="Suas aulas gratuitas já estão no seu e-mail" />;
}
